// extracted by mini-css-extract-plugin
export default {"root":"vuGkcpl50qcwXsgWAKVH","open":"nmviXtRYwL5kWORrOUbM","ul":"cIR3y3SaULoNpSCPoh5v","li":"sIUqbxYOutscsE3_Z23t","link":"Fmlcyj5hS5BFG6LqLkUY"};